import { init as initProductList } from './product-list/product-list';
import { init as initStoreFilter } from './product-list/store_filter.entry';
import { init as initPriceCaller } from '@/commons/component/price/price';
import { init as initSeoLinks } from './product-list/seoLinks';
import { init as initSelect } from '@/commons/select';
import './../legacy/floors/product-filters/product-filters.legacy';
import { init as initProductFilters } from './product-list/product-filters';
import { init as initFilters } from './product-list/filter';

export function init() {
  initSeoLinks();
  initProductList();
  if (document.querySelectorAll('.store-filter-data').length > 0) {
    initStoreFilter();
  }
  initPriceCaller();
  initFilters();
  initProductFilters();
  cube.event.on('listPageElementsRefresh', () => {
    initSelect();
    cube.productSlider.init();
  });
}



// WEBPACK FOOTER //
// ./src/catalog/product-list.entry.js